// Font definitions for poster typography
export const fontDefinitions: Record<string, string> = {
  "System UI": "system-ui, sans-serif",
  "Transitional": "Charter, 'Bitstream Charter', 'Sitka Text', Cambria, serif",
  "Old Style": "'Iowan Old Style', 'Palatino Linotype', 'URW Palladio L', P052, serif",
  "Humanist":
    "Seravek, 'Gill Sans Nova', Ubuntu, Calibri, 'DejaVu Sans', source-sans-pro, sans-serif",
  "Geometric Humanist": "Avenir, Montserrat, Corbel, 'URW Gothic', source-sans-pro, sans-serif",
  "Classical Humanist": "Optima, Candara, 'Noto Sans', source-sans-pro, sans-serif",
  "Neo-Grotesque":
    "Inter, Roboto, 'Helvetica Neue', 'Arial Nova', 'Nimbus Sans', Arial, sans-serif",
  "Monospace Slab Serif": "'Nimbus Mono PS', 'Courier New', monospace",
  "Monospace Code":
    "ui-monospace, 'Cascadia Code', 'Source Code Pro', Menlo, Consolas, 'DejaVu Sans Mono', monospace",
  "Industrial":
    "Bahnschrift, 'DIN Alternate', 'Franklin Gothic Medium', 'Nimbus Sans Narrow', sans-serif-condensed, sans-serif",
  "Rounded Sans":
    "ui-rounded, 'Hiragino Maru Gothic ProN', Quicksand, Comfortaa, Manjari, 'Arial Rounded MT', 'Arial Rounded MT Bold', Calibri, source-sans-pro, sans-serif",
  "Slab Serif": "Rockwell, 'Rockwell Nova', 'Roboto Slab', 'DejaVu Serif', 'Sitka Small', serif",
  "Antique":
    "Superclarendon, 'Bookman Old Style', 'URW Bookman', 'URW Bookman L', 'Georgia Pro', Georgia, serif",
  "Didone": "Didot, 'Bodoni MT', 'Noto Serif Display', 'URW Palladio L', P052, Sylfaen, serif",
  "Handwritten": "'Segoe Print', 'Bradley Hand', Chilanka, TSCu_Comic, casual, cursive",
};

export const themeBadgeColors: Record<string, string> = {
  "midnight": "bg-primary/90",
  "noir": "bg-slate-700/90",
  "vintage": "bg-amber-600/90",
  "modern": "bg-emerald-600/90",
  "cyberpunk": "bg-purple-600/90",
  "minimal": "bg-slate-700/90",
  "minimalist": "bg-slate-700/90",
  "classic": "bg-indigo-600/90",
  "retro": "bg-orange-600/90",
  "default": "bg-primary/90",
};

export const popularCities = [
  { city: "Copenhagen", country: "Denmark" },
  { city: "Aarhus", country: "Denmark" },
  { city: "New York", country: "USA" },
  { city: "London", country: "UK" },
  { city: "Paris", country: "France" },
  { city: "Tokyo", country: "Japan" },
  { city: "Berlin", country: "Germany" },
  { city: "Amsterdam", country: "Netherlands" },
  { city: "Barcelona", country: "Spain" },
  { city: "Rome", country: "Italy" },
];

export function showSuccess(message: string) {
  const toast = document.createElement("div");
  toast.className =
    "fixed top-24 left-1/2 -translate-x-1/2 z-[9999] px-6 py-3 rounded-xl bg-emerald-500 text-white font-semibold shadow-lg animate-fade-in";
  toast.textContent = message;
  document.body.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity = "0";
    toast.style.transition = "opacity 0.3s ease";
    setTimeout(() => document.body.removeChild(toast), 300);
  }, 2500);
}

export function showError(message: string) {
  alert(`Error: ${message}`);
}
